export const environment = {
  production: true,
  api_url: '/api',
  apiKey: 'AIzaSyD74wiUgCLgLc-iffEXz3f_IJF-P-qHDiI', // for AgmCoreModule
};
